// src/utils/textUtils.js

/**
 * Normaliza una cadena de texto para comparaciones seguras y tolerantes:
 * - Convierte a minúsculas y elimina espacios circundantes
 * - Normaliza caracteres Unicode eliminando diacríticos/acentos (NFD)
 * - Remueve signos de puntuación y caracteres especiales
 * - Colapsa espacios en blanco repetidos en un único espacio
 *
 * @param {string|any} text - Texto a normalizar
 * @returns {string} - Cadena limpia y normalizada
 */
export const normalizeText = (text) => {
  if (text === null || text === undefined) return '';
  return String(text)
    .toLowerCase()
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[!"#$%&()*+,\-.\/:;<=>?@[\\\]^_`{|}~]/g, '')
    .replace(/\s+/g, ' ');
};

/**
 * Alias de normalizeText para compatibilidad con useGameEngine y validadores de quiz.
 */
export const normalizeAnswer = normalizeText;

/**
 * Compara dos cadenas de texto de forma segura tras aplicar normalización.
 *
 * @param {string|any} a - Primer texto
 * @param {string|any} b - Segundo texto
 * @returns {boolean} - true si ambas cadenas son equivalentes
 */
export const compareNormalized = (a, b) => {
  if (a === null || a === undefined || b === null || b === undefined) return false;
  return normalizeText(a) === normalizeText(b);
};

/**
 * Formatea marcas Markdown básicas (como **negrita**) a elementos HTML con estilos de Tailwind CSS.
 *
 * @param {string|any} text - Texto con sintaxis Markdown
 * @returns {string} - Cadena HTML formateada
 */
export const formatMarkdownText = (text) => {
  if (!text) return '';

  return String(text)
    // Reemplaza **texto** por una etiqueta strong con clases de Tailwind
    .replace(/\*\*(.*?)\*\*/g, '<strong class="font-black text-indigo-700 bg-indigo-50/50 px-1 rounded-md">$1</strong>');
};

/**
 * Alias de formatMarkdownText para retrocompatibilidad con useGrammarLogic y GrammarTopicCard.
 */
export const formatText = formatMarkdownText;
